import { 
  NgModule,
  ErrorHandler 
} from '@angular/core';

import { BrowserModule }        from '@angular/platform-browser';
import { FormsModule }          from '@angular/forms';
import { HttpClientModule }     from '@angular/common/http';
import { RouterModule }         from '@angular/router';

import { AppComponent }         from './app-component';
import { AppNavigation }        from './app-navigation';

import { 
  routing,
  appRoutingProviders  
} from './app-routing';

import { GlobalErrorHandler } from 'source/app/controls/services/logging/global-error-handler';
import { MessageToast } from 'test/views/home/toast/message-toast';
import { WelcomeComponent } from 'test/views/home/welcome/welcome-component';
import { TreeComponent } from 'test/views/home/tree/tree-component';
import { TooltipComponent } from 'test/views/home/tool-tip/tool-tip-component';
import { ToolbarComponent } from 'test/views/home/toolbar/toolbar-component';
import { ToastComponent } from 'test/views/home/toast/toast-component';
import { TextBoxComponent } from 'test/views/home/text-box/text-box-component';
import { TabsComponent } from 'test/views/home/tabs/tabs-component';
import { SwitchComponent } from 'test/views/home/switch/switch-component';
import { SliderComponent } from 'test/views/home/slider/slider-component';
import { SidenavComponent } from 'test/views/home/sidenav/sidenav-component';
import { SidebarComponent } from 'test/views/home/sidebar/sidebar-component';
import { RadioButtonComponent } from 'test/views/home/radio-button/radio-button-component';
import { PrimitivesComponent } from 'test/views/home/primitives/primitives-component';
import { PanelsComponent } from 'test/views/home/panels/panels-component';
import { ModalsComponent } from 'test/views/home/modals/modals-component';
import { MenuComponent } from 'test/views/home/menu/menu-component';
import { ListBoxComponent } from 'test/views/home/list-box/list-box-component';
import { Layout15Component } from 'test/views/home/layout/layout-15-component';
import { Layout14Component } from 'test/views/home/layout/layout-14-component';
import { Layout13Component } from 'test/views/home/layout/layout-13-component';
import { Layout12Component } from 'test/views/home/layout/layout-12-component';
import { IconsModule } from 'source/app/controls/components/icons/icons-module';
import { HomeComponent } from 'test/views/home/home-component';
import { BarComponent } from 'test/views/home/bar/bar-component';
import { BreadcrumbComponent } from 'test/views/home/breadcrumb/breadcrumb-component';
import { BusyIndicatorsComponent } from 'test/views/home/busy-indicators/busy-indicators-component';
import { ButtonsComponent } from 'test/views/home/buttons/buttons-component';
import { CardsComponent } from 'test/views/home/cards/cards-component';
import { ChartsComponent } from 'test/views/home/charts/charts-component';
import { CheckBoxComboBoxComponent } from 'test/views/home/check-box-combo-box/check-box-combo-box-component';
import { CheckBoxComponent } from 'test/views/home/check-box/check-box-component';
import { CheckBoxListBoxComponent } from 'test/views/home/check-box-list-box/check-box-list-box-component';
import { ComboBoxComponent } from 'test/views/home/combo-box/combo-box-component';
import { ContextMenuComponent } from 'test/views/home/context-menu/context-menu-component';
import { DevPlaygroundComponent } from 'test/views/home/dev-playground/dev-playground-component';
import { ExpanderComponent } from 'test/views/home/expander/expander-component';
import { FormControlsComponent } from 'test/views/home/form-controls/form-controls-component';
import { GraphComponent } from 'test/views/home/graph/graph-component';
import { GridComponent } from 'test/views/home/grid/grid-component';
import { IconsComponent } from 'test/views/home/icons/icons-component';
import { LayoutComponent } from 'test/views/home/layout/layout-component';
import { Layout1Component } from 'test/views/home/layout/layout-1-component';
import { Layout2Component } from 'test/views/home/layout/layout-2-component';
import { Layout3Component } from 'test/views/home/layout/layout-3-component';
import { Layout5Component } from 'test/views/home/layout/layout-5-component';
import { Layout4Component } from 'test/views/home/layout/layout-4-component';
import { Layout6Component } from 'test/views/home/layout/layout-6-component';
import { Layout7Component } from 'test/views/home/layout/layout-7-component';
import { Layout8Component } from 'test/views/home/layout/layout-8-component';
import { Layout9Component } from 'test/views/home/layout/layout-9-component';
import { Layout10Component } from 'test/views/home/layout/layout-10-component';
import { Layout11Component } from 'test/views/home/layout/layout-11-component';
import { ControlsModule } from 'index';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    routing,
    ControlsModule,
    IconsModule,
  ],
  declarations: [ 
    AppComponent,        
    HomeComponent,    
    BarComponent,
    BreadcrumbComponent,
    BusyIndicatorsComponent,
    ButtonsComponent,
    CardsComponent,
    ChartsComponent,
    CheckBoxComponent,
    CheckBoxComboBoxComponent,
    CheckBoxListBoxComponent,
    ComboBoxComponent,    
    ContextMenuComponent,
    DevPlaygroundComponent,
    ExpanderComponent,
    FormControlsComponent,
    GraphComponent,
    GridComponent,
    IconsComponent,
    LayoutComponent,
    Layout1Component,
    Layout2Component,
    Layout3Component,
    Layout4Component,
    Layout5Component,
    Layout6Component,
    Layout7Component,
    Layout8Component,
    Layout9Component,
    Layout10Component,
    Layout11Component,
    Layout12Component,
    Layout13Component,
    Layout14Component,
    Layout15Component,
    ListBoxComponent,
    MenuComponent,
    MessageToast,
    ModalsComponent,
    PanelsComponent,
    PrimitivesComponent,
    RadioButtonComponent,
    SidebarComponent,
    SidenavComponent,
    SliderComponent,
    SwitchComponent,
    TabsComponent,
    TextBoxComponent,
    ToastComponent,
    ToolbarComponent,
    TooltipComponent,
    TreeComponent,
    WelcomeComponent
  ],
  entryComponents: [
    MessageToast,
  ],
  providers: [ 
    appRoutingProviders, 
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    AppNavigation, 
  ],
  bootstrap: [ AppComponent ]
})

export class AppModule { }


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/app-module.ts